import React from 'react';
import clsx from 'clsx';
import CustomPortableText from 'shared/studio/PortableText/PortableText';
import { SanityBlock, SanityKeyed, ParagraphTextPage } from 'types/studio/studio';
import { Typography } from '@ag1/ui';
import styles from './Paragraph.module.scss';

type ParagraphProps = {
  headline?: Array<SanityKeyed<SanityBlock>>;
  text: Array<SanityKeyed<SanityBlock>>;
  isMono: boolean | undefined;
  textColor: string;
} & Pick<ParagraphTextPage, 'wideContainer'>;

export const Paragraph = ({ headline, text, isMono, textColor, wideContainer }: ParagraphProps) => (
  <div className={styles.wrap}>
    {headline && (
      <Typography
        variant="headlineSans"
        size="3"
        component="div"
        noPadding
        style={{ color: textColor }}
        className={clsx(isMono && styles.monoType)}>
        <CustomPortableText value={headline} />
      </Typography>
    )}
    <Typography variant="body" size="1" noPadding style={{ color: textColor }}>
      <CustomPortableText
        value={text}
        className={clsx(styles.text, wideContainer && styles.largeText)}
      />
    </Typography>
  </div>
);
